<template>
  <div id="ranking-board">
    <!--    <div class="ranking-board-title">最新遥测数据</div>-->
    <!--    <dv-scroll-ranking-board :config="config" style="width: 100%"/>-->
    <div class="dc-top">
      <dv-border-box8 style="padding: 20%;">
        <!--      <div class="compare">-->
        <div class="main-value" style=" margin-top: -23%;">
          <div class="deviceName">{{$t("totalDevice")}}</div>
          <div class="deviceNum">{{totalDevice}}</div>
        </div>
        <dv-decoration2 style="width: 100%; height: 5px;"/>
        <div class="compare-value">
          <div class="deviceName">{{$t("onDevice")}}</div>
          <div class="deviceNum">{{onlineDevice}}</div>
        </div>
        <dv-decoration2 style="width: 100%; height: 5px;"/>
        <div class="compare-value">
          <div class="deviceName">{{$t("offDevice")}}</div>
          <div class="deviceNum">{{offlineDevice}}</div>
        </div>
        <!--      </div>-->
      </dv-border-box8>
    </div>
    <div class="dc-bottom">
      <div class="board-title" >
        <div class="border-title-left">
          <span class="border-title-leftContent">{{$t("latestData")}}</span>
        </div>
<!--        <div class="border-title-middle">-->
<!--          <span class="border-title-middleContent"  v-show="fxFlg" @click="switchClick">开关控制</span>-->
<!--        </div>-->
<!--        <div class="border-title-middle">-->
<!--          <span  class="border-title-middleContent" v-show="fxFlg" @click="parameterClick">参数设置</span>-->
<!--        </div>-->
<!--        <div @click="changeUrl" style="width: 20%; cursor: pointer; text-align: center; color: #08EAA8"> {{$t("entomopathy")}}</div>-->
        <div class="border-title-right">
          <span @click="popClick" class="border-title-rightContent">{{$t("alarm")}}</span>
        </div>
      </div>
      <dv-scroll-board :config="config"/>
    </div>
  </div>
</template>

<script>

  import moment from "moment";
  import {getAttributesClient, getAttributesShared, getCredentials} from "../untils/api/home";

  export default {
    name: 'RankingBoard',
    props: ["lineInfo"],
    data() {
      return {
        config: {
          header: [this.$t('time'), this.$t('type'), this.$t('value')],
          data: [],
          index: false,
          columnWidth: [250, 160, 180],
          align: ['center'],
          rowNum: 13,
          headerBGC: '#3E528B',//#51b9fb #00baff
          headerHeight: 40,
          oddRowBGC: 'rgba(0, 44, 81, 0.8)',
          evenRowBGC: 'rgba(10, 29, 50, 0.8)',
          waitTime: 1500
        },
        deviceInfo: {},
        totalDevice: 0,
        onlineDevice: 0,
        offlineDevice: this.lineInfo,
        labelName: [],
        map1: null,
        map2: null,
        fxFlg: false
      }
    },

    watch: {
      lineInfo() {
        this.offlineDevice = this.lineInfo;
        this.onlineDevice = this.totalDevice - this.offlineDevice;
      }
    },

    methods: {
      /**
       * 根据最新遥测数据 设置样式
       * @param deviceId
       * @param deciveKey
       * @returns {Promise<unknown>}
       */
      getDeviceValueInfo(deviceId, response) {
        //无数据  原始数据清空
        if (response === 'false' || JSON.stringify(response) == "{}") {
          const {config} = this;
          this.config.data = [];
          this.config = {...config};
          return;
        }
        this.labelName = [];
        this.deviceInfo = deviceId;
        //数据存在  设置样式
        this.setConfig(response);
        this.fxFlg = localStorage.getItem("fx") === "fx" ? true : false;
      },

      /**
       * 设置样式
       * @param rankingBoardData
       */
      setConfig(rankingBoardData) {
        let HIFlg = localStorage.getItem("HI") === "HI" ? true : false;
        let TGFlg = localStorage.getItem("TG") === "TG" ? true : false;
        let WDFlg = localStorage.getItem("WD") === "WD" ? true : false;
        const {config} = this;
        let newWarnList = eval(localStorage.getItem("warnList"));
        for(let obj in newWarnList) {
          this.map1.set(newWarnList[obj][0], newWarnList[obj][1]);
          this.map2.set(newWarnList[obj][0], newWarnList[obj][2]);
        }
        //初期化数组
        let arrListResponse = [];
        let configResponse = [];
        let levelRefer = localStorage.getItem('levelRefer');//获取设置水位值
        let snowRefer = localStorage.getItem('snowRefer'); //获取设置雪深值
        let emptyHRefer = localStorage.getItem('emptyHRefer');//获取设置空高值
        let noiseRefer = localStorage.getItem('noiseRefer');//获取设置噪声值
        //遍历历史遥测数据对象
        for (let obj in rankingBoardData) {
          //获取每种遥测数据的时间以及数值
          for (let i = 0; i < rankingBoardData[obj].length; i++) {
            let arrList = {};
            let label = {};
            arrList.name = this.$t(obj);
            arrList.ts = rankingBoardData[obj][i].ts;
            if(obj === 'longitude' || obj === 'latitude'){//当前为经纬度属性
              // arrList.value = parseFloat(rankingBoardData[obj][i].value).toFixed(5);
              arrList.value = parseFloat(rankingBoardData[obj][i].value).toString();
            } else if(obj == 'level' || obj == 'Rwater' || obj == 'waterlevel'){//当前为水位属性
              // arrList.value = Math.abs(parseFloat(levelRefer) + parseFloat(rankingBoardData[obj][i].value)).toFixed(2);
              arrList.value = Math.abs(parseFloat(levelRefer) + parseFloat(rankingBoardData[obj][i].value)).toFixed(4).toString();
            } else if(obj == 'snowHeight' || obj == 'snowheight') {//当前为雪深属性
              arrList.value = Math.abs(parseFloat(snowRefer) + parseFloat(rankingBoardData[obj][i].value)).toFixed().toString();
            } else if(obj == 'emptyH' && !(emptyHRefer.toString() == '0')) {
              arrList.value = parseFloat(rankingBoardData[obj][i].value).toString();
              let level = (parseFloat(emptyHRefer) - parseFloat(rankingBoardData[obj][i].value)) < 0 ? 0 : parseFloat(emptyHRefer) - parseFloat(rankingBoardData[obj][i].value);
              let flowNum =  (level *2399.5).toFixed(4).toString();
              arrListResponse.push({
                name: '瞬时流量,L/dm³',
                ts: rankingBoardData[obj][i].ts,
                value: flowNum
              })
            } else if(obj == 'flowNum') {
              arrList.value = (parseFloat(rankingBoardData[obj][i].value) * 6.28).toFixed(2);
            } else if(obj == 'noise' || obj == 'noi' || obj == 'noise1' || obj == 'noise2') {
              arrList.value = Math.abs(parseFloat(noiseRefer) + parseFloat(rankingBoardData[obj][i].value)).toFixed(1).toString();
            } else if(obj == 'ammoniaIon') {
              if(rankingBoardData.hasOwnProperty('waterPH')) {
                let amnitro = parseFloat(rankingBoardData['ammoniaIon'][0].value);
                let waterPH = parseFloat(rankingBoardData['waterPH'][0].value);
                if(rankingBoardData.hasOwnProperty('waterT')) {
                  let waterT = parseFloat(rankingBoardData['waterT'][0].value);
                  let result = amnitro * Math.pow(10, waterPH - (-0.032 * waterT + 10.042)) + amnitro;
                  let amnitroResult = result.toFixed(2);
                  arrList.value = amnitroResult;
                } else {
                  let result = amnitro * Math.pow(10, (waterPH - 9.25)) + amnitro;
                  let amnitroResult = parseFloat(result).toFixed(2);
                  arrList.value = amnitroResult;
                }
              } else {
                arrList.value = parseFloat(rankingBoardData[obj][i].value).toString();
              }
            } else if(HIFlg == true && obj == 'ambientHumidity') {
              arrList.value = parseFloat(rankingBoardData[obj][i].value).toString();
              if(rankingBoardData.hasOwnProperty('ambientTemperature')) {
                let T = rankingBoardData['ambientTemperature'][0].value;
                let RH = rankingBoardData['ambientHumidity'][0].value;
                let HI = this.calculateHeatIndex(T, RH).toFixed(3);
                arrListResponse.push({
                  name: '热量指数',
                  ts: rankingBoardData[obj][i].ts,
                  value: HI
                })
              }
            } else if(TGFlg == true && obj == 'ambientTemperature') {
              arrList.value = parseFloat(rankingBoardData[obj][i].value).toString();
              if(rankingBoardData.hasOwnProperty('ambientHumidity') && rankingBoardData.hasOwnProperty('windSpeed')) {
                let temp = parseFloat(rankingBoardData[obj][i].value);
                let hum = parseFloat(rankingBoardData['ambientHumidity'][i].value);
                let speed = parseFloat(rankingBoardData['windSpeed'][i].value);
                let AT = this.calculateAT(temp, hum, speed).toFixed(2);
                arrListResponse.push({
                  name: this.$t('AT'),
                  ts: rankingBoardData[obj][i].ts,
                  value: AT
                })
              }
            } else if(WDFlg == true && obj == 'windDirection') {
              arrList.value = rankingBoardData[obj][i].value + ".0";
            } else if(obj == 'Rday1') {
              arrList.value = (parseFloat(rankingBoardData[obj][i].value )* 0.36).toFixed(2);
            } else { //当前为非水位属性
              // arrList.value = parseFloat(rankingBoardData[obj][i].value).toFixed(2);
              arrList.value = parseFloat(rankingBoardData[obj][i].value).toString();
            }
            label.upperCH = this.$t(obj).split(',')[0] + this.$t('up');
            label.upperEN = obj + '_up';
            label.lowerCH = this.$t(obj).split(',')[0] + this.$t('low');
            label.lowerEN = obj + '_low';
            label.up = this.map1.get(obj) === undefined ? 0 : this.map1.get(obj);
            label.low = this.map1.get(obj) === undefined ? 0 : this.map2.get(obj);
            arrListResponse.push(arrList);
            this.labelName.push(label);
          }
        }
        //倒序排序
        arrListResponse.sort(function (a, b) {
          return b.ts < a.ts ? -1 : 1
        });

        for (let i = 0; i < arrListResponse.length; i++) {
          if(this.$t(arrListResponse[i].name).split(',')[0] == '天气状况') {
            let weaState = '';
            switch (parseInt(arrListResponse[i].value)) {
              case 0:
                weaState = '晴';
                break;
              case 16:
                weaState = '大雨';
                break;
              case 17:
                weaState = '中雨';
                break;
              case 18:
                weaState = '小雨';
                break;
              case 32:
                weaState = '大毛毛雨';
                break;
              case 33:
                weaState = '中毛毛雨';
                break;
              case 34:
                weaState = '小毛毛雨';
                break;
              case 50:
                weaState = '大雪';
                break;
              case 51:
                weaState = '中雪';
                break;
              case 52:
                weaState = '小雪';
                break;
              case 64:
                weaState = '烟';
                break;
              case 80:
                weaState = '雾';
                break;
              case 96:
                weaState = '冰雪或高空坠物';
                break;
              case 153:
                weaState = '飞虫或异常遮挡';
                break;
            }
            let weaList = [this.dateFormat(arrListResponse[i].ts), this.$t(arrListResponse[i].name).split(',')[0], weaState];
            configResponse.push(weaList);
          } else {
            let arrList = [this.dateFormat(arrListResponse[i].ts), this.$t(arrListResponse[i].name).split(',')[0],
              this.$t(arrListResponse[i].name).split(',')[1] === undefined ? arrListResponse[i].value : arrListResponse[i].value + this.$t(arrListResponse[i].name).split(',')[1]];
            configResponse.push(arrList);
            if( this.$t(arrListResponse[i].name).split(',')[0] === '风向'){
              let windName = '';
              if(arrListResponse[i].value < 22.5 || arrListResponse[i].value >= 337.5){
                windName = '北风';
              } else if(arrListResponse[i].value >= 22.5 && arrListResponse[i].value < 67.5){
                windName = '东北风';
              }else if(arrListResponse[i].value >= 67.5 && arrListResponse[i].value < 112.5) {
                windName = '东风';
              } else if(arrListResponse[i].value >= 112.5 && arrListResponse[i].value < 157.5){
                windName = '东南风'
              } else if(arrListResponse[i].value >= 157.5 && arrListResponse[i].value < 202.5){
                windName = '南风';
              }else if(arrListResponse[i].value >= 202.5 && arrListResponse[i].value < 247.5) {
                windName = '西南风';
              } else if(arrListResponse[i].value >= 247.5 && arrListResponse[i].value < 292.5) {
                windName = '西风';
              } else if(arrListResponse[i].value >= 292.5 && arrListResponse[i].value < 337.5 ){
                windName = '西北风';
              }
              let windList = [this.dateFormat(arrListResponse[i].ts), '风向', windName];
              configResponse.push(windList);
            }
          }

        }
        //对data 重新赋值
        this.config.data = configResponse;
        this.config = {...config};
        console.log("RankingBoardInfo", this.config.data)
        localStorage.setItem("warnList",null);
      },

      calculateHeatIndex(T, RH) {
        // 系数定义
        const c1 = -42.379;
        const c2 = 2.04901523;
        const c3 = 10.14333127;
        const c4 = -0.22475541;
        const c5 = -0.00683783;
        const c6 = -0.05481717;
        const c7 = 0.00122874;
        const c8 = 0.00085282;
        const c9 = -0.00000199;

        // 热量指数计算
        let HI = c1 + (c2 * T) + (c3 * RH) + (c4 * T * RH) + (c5 * T * T) + (c6 * RH * RH) +
          (c7 * T * T * RH) + (c8 * T * RH * RH) + (c9 * T * T * RH * RH);

        return HI;
      },

      calculateAT(temp, hum, speed) {
        let e = hum/100*6.105*2.71828*17.27*temp/(237.7+temp);
        let AT = 1.07*temp+0.2*e-0.65*speed-2.7;
        return AT;
      },

      /**
       * 格式化时间戳
       * @param timestamp
       * @returns {string}
       */
      dateFormat(timestamp) {
        if (timestamp && timestamp != "") {
          let dateStr = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
          return dateStr;
        }
        return "-";
      },

      /**
       * 获取总设备
       * @param total
       */
      setTotalDevice(total) {
        this.totalDevice = total;
        if (this.offlineDevice === 0) {
          this.onlineDevice = this.totalDevice - this.offlineDevice;
        }
      },

      /**
       * 根据选中的值获取设备数据
       * @param deviceId
       */
      getLeftCredentialsInfo(deviceId){
        //访问api获取设备信息
        getCredentials(deviceId).then(response => {
          //获取客户端遥测数据上下限值
          this.getClientInfos(response.credentialsId);
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取客户端遥测数据上下限值
       * @param credentialsId
       */
      getClientInfos(credentialsId) {
        this.map1 = null;
        this.map2 = null;
        this.map1 = new Map();
        this.map2 = new Map();
        //访问api
        getAttributesClient(credentialsId).then(response => {

          for (let obj in response.client) {
            if (obj.substring(obj.length - 3) === '_up') {
              this.map1.set(obj.substring(0,obj.length - 3), response.client[obj]);
            } else if (obj.substring(obj.length - 4) === '_low') {
              this.map2.set(obj.substring(0, obj.length - 4).toString(), response.client[obj])
            }
          }
        }).catch(error => {
          console.log("error", error)
        })

      },

      /**
       * 点击内容出现弹窗
       * @param value
       */
      popClick() {
        let originalList = JSON.parse(JSON.stringify(this.labelName));
        this.$popup({
          labelList: this.labelName,
          deviceInfo: this.deviceInfo,
          initList: originalList,
          click: () => {
          },
        })
      },

      switchClick() {
        this.$switchSetDialog({
          deviceInfo: this.deviceInfo,
        })
      },

      parameterClick() {
        this.$parameterSetDialog({
          deviceInfo: this.deviceInfo,
        })
      },

      changeUrl() {
        let url = 'http://120.220.14.53:8900/iotservice/login.html';
        window.open(url);
      }
      /**
       * 跳转页面
       */
      // changeUrl() {
      //   let loginName = '';
      //   let loginPwd = '';
      //   getAttributesShared(this.deviceInfo.entityType, this.deviceInfo.id).then(response => {
      //     for(let i = 0; i < response.length; i++) {
      //       if(response[i].key === 'agriculture_loginName') {
      //         loginName = response[i].value;
      //       } else if(response[i].key === 'agriculture_loginPwd') {
      //         loginPwd = response[i].value;
      //       }
      //
      //       if(i === response.length - 1 ) {
      //         if(loginName !== '' && loginPwd !== '') {
      //           let url = 'http://farm.0531yun.cn/#/logindo?loginName=' + loginName + '&loginPwd=' + loginPwd + '&returnPage=index';
      //           window.open(url);
      //           break;
      //         } else {
      //           this.$message({
      //             showClose: true,
      //             type: "warning",
      //             message: this.$t('entomopathyError')
      //           });
      //         }
      //       }
      //     }
      //   }).catch(error => {
      //     console.log("error",error)
      //   })
      //   // let loginName = "jnrstest";
      //   // let loginPwd = "jnrstest321";
      //   // let url = 'http://farm.0531yun.cn/#/logindo?loginName=' + loginName + '&loginPwd=' + loginPwd + '&returnPage=index';
      //   // window.open(url)
      // },
    }
  }
</script>

<style lang="less">
  @import "less/rankingBoard.less";
</style>



// WEBPACK FOOTER //
// src/components/RankingBoard.vue